import * as Sentry from "@sentry/gatsby";

const ignoreLog = process.env.GATSBY_SENTRY_IGNORE_CONSOLE_LOG === "true";

Sentry.init({
  dsn: "https://229c37c3668b4b1f0500d91d72bc0b20@o256546.ingest.us.sentry.io/4507462684114944",
  environment: process.env.GATSBY_SENTRY_ENVIRONMENT,
  enabled: process.env.GATSBY_SENTRY_ENVIRONMENT !== undefined,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.1,
  release: process.env.GATSBY_SENTRY_RELEASE,
  beforeBreadcrumb(breadcrumb) {
    if (breadcrumb.level === "log" && ignoreLog) {
      return null;
    }
    return breadcrumb;
  },
  beforeSend(event) {
    // Add Tealium visitor ID to the event scope
    const visitorId = window.utag_data?.tealium_visitor_id?.toString();
    if (visitorId) {
      event.tags = {
        ...event.tags,
        tealium_visitor_id: visitorId,
      };
    }

    return event;
  },
});
